import { Alert } from "Shared/Components/Alert";
import { WarningAmber } from "@mui/icons-material";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
} from "@mui/material";
import type { FC } from "react";

type ModalProps = {
	isOpen: boolean;
	handleClose?: () => void;
	onSubmit: () => void;
	isPending?: boolean;
};

export const ExpressPayoutConfirmModal: FC<ModalProps> = (props) => {
	const { isOpen, handleClose, onSubmit, isPending } = props;

	const handleSubmit = () => {
		onSubmit();
	};

	return (
		<Dialog open={isOpen} onClose={handleClose}>
			<DialogTitle>{"Confirm express payout"}</DialogTitle>
			<DialogContent sx={{ pb: 0 }}>
				<Alert
					message={"This action create charge and payment record"}
					color="warning"
					icon={<WarningAmber />}
					sx={{ marginTop: 1 }}
				/>
			</DialogContent>
			<DialogActions>
				<Button variant="outlined" onClick={() => handleClose?.()}>
					{"Cancel"}
				</Button>
				<Button
					variant="contained"
					color="success"
					onClick={handleSubmit}
					loading={isPending}
				>
					{"Submit"}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
